"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); } // +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var operationRouter = {
  path: '/operation',
  component: _layout.default,
  redirect: '/operation/modifyStoreInfo',
  name: 'Operation',
  meta: {
    title: '设置',
    icon: 'clipboard',
    roles: ['admin']
  },
  children: [{
    path: 'modifyStoreInfo',
    name: 'modifyStoreInfo',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/systemSetting/modifyStoreInfo'));
      });
    },
    meta: {
      title: '商户基本设置',
      icon: 'clipboard'
    }
  }, {
    path: 'roleManager',
    name: 'RoleManager',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/systemSetting/administratorAuthority'));
      });
    },
    meta: {
      title: '管理权限',
      icon: 'clipboard',
      roles: ['admin']
    },
    children: [{
      path: 'identityManager',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/systemSetting/administratorAuthority/identityManager'));
        });
      },
      name: 'identityManager',
      meta: {
        title: '角色管理',
        icon: ''
      }
    }, {
      path: 'adminList',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/systemSetting/administratorAuthority/adminList'));
        });
      },
      name: 'adminList',
      meta: {
        title: '管理员列表',
        icon: ''
      }
    }]
  }, {
    path: 'export',
    name: 'systemExport',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/systemSetting/systemExport'));
      });
    },
    meta: {
      title: '数据导出',
      icon: 'clipboard'
    },
    hidden: false
  }, {
    path: 'freightSet',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/systemSetting/deliverGoods/freightSet'));
      });
    },
    name: 'freightSet',
    meta: {
      title: '运费模板',
      noCache: true
    }
  }, {
    path: 'deliveryPersonnel',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/systemSetting/deliveryPersonnel/index'));
      });
    },
    name: 'deliveryPersonnel',
    meta: {
      title: '配送员管理',
      noCache: true
    }
  }, {
    path: 'printing',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/systemSetting/printing/index'));
      });
    },
    name: 'printing',
    meta: {
      title: '打印配置',
      noCache: true
    },
    children: [{
      path: 'printreceipt',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/systemSetting/printing/printReceipt/index'));
        });
      },
      name: 'printreceipt',
      meta: {
        title: '小票打印',
        noCache: true
      }
    }, {
      //id:商品id，isDisabled：是否能编辑(1不能，2能)，isCopy：是否是采集商品(1是，2不是),productType:商品类型
      path: 'printreceipt/creatPrintreceipt/:id?',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/systemSetting/printing/printReceipt/creatPrintreceipt'));
        });
      },
      name: 'creatPrintreceipt',
      meta: {
        title: '小票配置',
        noCache: true,
        activeMenu: "/operation/printing/printreceipt"
      },
      hidden: true
    }, {
      path: 'electrsheet',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/systemSetting/printing/electrsheet/index'));
        });
      },
      name: 'electrsheet',
      meta: {
        title: '电子面单',
        noCache: true
      }
    }]
  }, {
    path: 'mallConfiguration',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/systemSetting/mallConfiguration'));
      });
    },
    name: 'mallConfiguration',
    meta: {
      title: 'PC商城设置',
      noCache: true
    }
  }, {
    path: 'businessAddress',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/systemSetting/businessAddress'));
      });
    },
    name: 'businessAddress',
    meta: {
      title: '商家地址管理',
      noCache: true
    }
  }, {
    path: 'logisticsManagement',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/systemSetting/logisticsManagement/index.vue'));
      });
    },
    name: 'LogisticsManagement',
    meta: {
      title: '物流管理',
      noCache: true
    }
  }]
};
var _default = exports.default = operationRouter; //collate